import { CustomCardProps } from "./type";
import CustomToolTip from "./ToolTip";
import { INTERACTIVE_TILE_CLASS } from "@/shared/constants";
import { cn } from "@/shared/utils/utils";

const CustomCard = (props: CustomCardProps): React.ReactElement => {
  const {
    cardIcon,
    cardTitle,
    cardSubtitle,
    titleCss,
    subTitleCss,
    children,
    innerParent,
    alt,
    ariaLabel,
    onClick,
    tooltipContent,
    tooltipSide = "top",
  } = props;

  const cardClassName = cn(
    "card h-full w-full text-left p-0 border-none bg-transparent",
    INTERACTIVE_TILE_CLASS,
    onClick && "cursor-pointer",
  );

  const content = (
    <>
      <img
        src={cardIcon}
        alt={alt ?? ""}
        className="float-right size-7 max-xs:size-6 max-[480px]:size-7"
      />
      <div
        className={`card-inner-wrapper flex flex-col justify-end h-full ${innerParent}`}
      >
        <p>
          <data
            className={`text-lg xs:text-[22px] min-[480px]:text-[26px] md:text-[30px] tracking-wide font-medium ${subTitleCss}`}
          >
            {cardSubtitle}
          </data>
        </p>
        <h3
          className={`tracking-wide text-xs xs:text-sm sm:text-base ${titleCss}`}
        >
          {cardTitle}
        </h3>
        {children}
      </div>
    </>
  );

  const cardElement = onClick ? (
    <button
      type="button"
      className={cardClassName}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {content}
    </button>
  ) : (
    <div className={cardClassName}>{content}</div>
  );

  if (tooltipContent) {
    return (
      <CustomToolTip
        triggerChild={cardElement}
        triggerContent={tooltipContent}
        side={tooltipSide}
      />
    );
  }

  return cardElement;
};

export default CustomCard;
